
const smaUIFeatureFlags = {
  jobs: false,
};

export default smaUIFeatureFlags;
